import Vue from 'vue';
import Vuex from 'vuex';

// Settings
import { countries, states } from '@/config/countriesAndStates';
// import zipCodes from '@/config/zipcodes'; // TODO: Remove this later, zip codes comes from server.

// modules
import auth from './auth';
import login from './login';
import users from './users';
import properties from './properties';
import cases from './cases';

Vue.config.devtools = true;
Vue.use(Vuex);

export default new Vuex.Store({
  strict: false,
  modules: {
    auth,
    login,
    users,
    properties,
    cases,
  },
  state: {
    doingAjax: false,
    maintenanceResponse: null,
    countries,
    states,
    
    // This must comme from the server later.
    zipCodes: [],
    thresholds: {},
  },
  getters: {},
  mutations: {
    setDoingAjax(state, b) {
      state.doingAjax = b;
    },
    setMaintenanceResponse(state, response) {
      state.maintenanceResponse = response;
    },
    setZipCodes(state, zipCodes) {
      state.zipCodes = zipCodes;
    },
    setThresholds(state, thresholds) {
      state.thresholds = thresholds;
    },
  },
  actions: {
    async getZipCodes({ commit }) {
      try {
        if (this.$sCache.get('regions')) {
          commit('setZipCodes', this.$sCache.get('regions'));
          return;
        }
       
        const { data } = await this.$axios.get('/zip-codes');
        if (data.success) {
          this.$sCache.set('regions', data.list);
          commit('setZipCodes', data.list);
        } else {
          this.$fatalError();
        }
        return false;
      } catch (err) {
        this.$defaultResponseController(err);
        return false;
      }
    },

    async getThresholds({ commit }) {
      try {
        if (this.$sCache.get('thresholds')) {
          commit('setThresholds', this.$sCache.get('thresholds'));
          return;
        }

        const { data } = await this.$axios.get('/settings/category/thresholds');
        if (data.success) {
          // Parse result
          let thresholds = {};
          for (let index in data.list) {
            thresholds[String(data.list[index].key).toLocaleLowerCase()] = Number(data.list[index].value);
          }
          this.$sCache.set('thresholds', thresholds);
          commit('setThresholds', thresholds);
          return;
        } 
        // this.$fatalError();
        return false;
      } catch (err) {
        this.$defaultResponseController(err);
        return false;
      }
    },

    async healthCheck({ commit }) { // eslint-disable-line
      const localAxios = this.$axios.create({
        baseURL: process.env.BASE_URL || '',
        headers: {},
      });

      const isMaintenance = document.location.href.indexOf('maintenance') !== -1;

      try {
        const response = await localAxios.get(`./status?t=${this.$dayjs().unix()}`);
        const status = String(response.data).match(/\[status=([^\]]+)\]/).pop();
        if (status === 'maintenance') {
          commit('setMaintenanceResponse', response.data);
          if (!isMaintenance) {
            window.location.href = '/maintenance';
            return;
          }
        } else {
          if (isMaintenance) {
            window.location.href = '/';
            return;
          }
        }
      } catch (err) {
        commit('setMaintenanceResponse', null);
        if (isMaintenance) {
          window.location.href = '/';
          return;
        }
      }
      
    },
  },
});
